import CardWrapper from "./CardWrapper"
import styles from "../../styles/portfolioManagerDashboard.module.scss"
import { BudgetChart } from '../../../../components/charts/DashboardCharts';

function BudgetCostCard({budgetChartData}) {
  return (
    <CardWrapper classNames={styles.budgetCostsCard}>
        <span className={styles.label}>Overall Budget</span>
        <div className={styles.budgetChartContainer}>
            <BudgetChart 
                budgetSummary={budgetChartData}
                currencySymbol= '$'
            />
        </div>
    </CardWrapper>
  )
}

export default BudgetCostCard
